/* RESPONSIBLE TEAM: team-tickets-1 */
import { fragment } from 'ember-data-model-fragments/attributes';
import Step from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';
import { buildValidations, validator } from 'ember-cp-validations';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';

const Validations = buildValidations({
  action: [
    validator('presence', true),
    validator('rule-action-is-valid', {
      message: 'operator.workflows.visual-builder.validations.empty-action-error',
    }),
  ],
});

export default class SetTicketCustomState extends Step.extend(Validations) {
  @fragment('rules/rule-action') declare action: any;

  get supportedChannels() {
    return SUPPORTED_CHANNELS.setTicketCustomState;
  }

  static get supportedContexts() {
    return [
      TargetContext.CustomerTicket,
      TargetContext.BackOfficeTicket,
      TargetContext.TrackerTicket,
    ];
  }

  static createNewStep(store: Store): SetTicketCustomState {
    return store.createRecord('operator/visual-builder/step/set-ticket-custom-state', {
      action: store.createFragment('rules/rule-action', {
        type: 'set-ticket-custom-state',
        justAdded: true,
        actionData: {},
      }),
      type: 'operator/visual-builder/step/set-ticket-custom-state',
    });
  }
}
